import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import moment from "moment";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router";

const News = ({ cmpnyNo, homepageInfo, url }) => {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  useEffect(() => {
    if (cmpnyNo) {
      getNotices(cmpnyNo);
    }
  }, [cmpnyNo]);

  const getNotices = async (cmpnyNo) => {
    const url = "/api/noticeList";
    const body = {
      cmpnyNo,
      gbn: "N",
      delYn: "N",
      offset: 0,
      pageNumber: 0,
      pageSize: 4,
      paged: true,
    };
    try {
      const res = await axios.post(url, body);
      let data = res.data.content;

      if (Array.isArray(data) && data.length > 0) {
        const originalData = [...data];
        while (data.length < 8) {
          data = data.concat(originalData.slice(0, 12 - data.length));
        }
      } else {
        data = [];
      }

      setNotices(data);
    } catch (error) {
      console.log(error);
    }
  };

  return notices && Array.isArray(notices) && notices.length > 0 ? (
    <div className="news">
      <div className="label">
        News <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </div>
      <div className="info">
        공지사항
        <span>
          <span>{homepageInfo?.cmpnyNm}의 다양한 공지사항입니다</span>
        </span>
      </div>
      <div className="newsContent">
        {notices.map((item, i) => (
          <div
            className="box"
            id={i}
            onClick={() => navigate(`/shop/${url}/shoppingNoticeView/${item.noticeNo}`)}>
            <div className="newsInfo">
              <span>{item.noticeSj}</span>
              <span>{item.noticeCl}</span>
              <span>{moment(item.createDt).format("YYYY.MM.DD")}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default News;
